module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxwYXRoIGZpbGw9IiMyMTkzRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTggOGMyLjIgMCA0LTEuOCA0LTRzLTEuOC00LTQtNC00IDEuOC00IDQgMS44IDQgNCA0em0wIDJjLTIuNyAwLTggMS4zLTggNHYyaDE2di0yYzAtMi43LTUuMy00LTgtNHoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/default-user-avatar.svg
// module id = lcp/
// module chunks = 4